module.exports = __webpack_public_path__ + "static/media/Fujairah1.346f8a2d.jpg";